module.exports = __webpack_public_path__ + "a5f7011391d0c1709b7b4902ef207f8c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-30.png
// module id = 3191
// module chunks = 0